import React from 'react';
import './styles.scss';

const CloseButton = props => {
    return (
        <button className="close-button" type="button" onClick={props.onClick}><span>{props.text}</span></button>
    );
};

export default CloseButton;